module.exports = __webpack_public_path__ + "static/media/noclass4.b18ae26d.png";